import React, { useEffect, useMemo } from "react";
import classNames from "classnames";
import { Link, useHistory } from "react-router-dom";
import { Footer } from "antd/lib/layout/layout";
import { Tabs, Table, Collapse, Col } from "antd";
import { NotFound, Spinner } from "../../ui-kit";
import Api from "../../api/Registry";
import { Role } from "../../api/Types";
import * as M from "moment";
import cn from "classnames";
import Constants from "../../constants/Common";
import {
  ArrowRightIco,
  CollapseIco,
  ExpandIco,
  ExportIco,
  OpenCardIco,
  WrapIco,
} from "../../assets/customIcons";
import defectRegister from "../../store/defectRegister";
import { observer } from "mobx-react-lite";

import "./index.scss";

const { TabPane } = Tabs;

const FooterComponent = observer(({ filter, onOpenValidator }) => {
  const history = useHistory();

  const cardMaxCount = 5;
  const [activeState, setActiveState] = React.useState("defectsTable");

  const { spPanes, setSPPanes, isExpandedDefect } = defectRegister;

  const onTabClick = (activeKey) => {
    setActiveState(activeKey);
  };

  const defectClick = (e) => {
    const defectId = Number(e);

    const pane = spPanes?.find((x) => x.card?.id === defectId);
    if (pane?.key) {
      setActiveState(String(pane.key));
    } else {
      Api.getFullCard(defectId).then((response) => {
        add(defectId, response.data);
      });
    }
    defectRegister.setDefectId();
  };

  if (defectRegister.defectId) {
    defectClick(defectRegister.defectId);
  }

  const onEdit = (targetKey, action) => {
    if (action === "remove") {
      const idx = spPanes.findIndex((x) => x.key === targetKey);
      remove(targetKey);
      if (targetKey === activeState) {
        setActiveState(String(spPanes[idx - 1].key));
      }
    } else if (action === "add") {
      add("", {});
    }
  };

  const remove = (key) => {
    const panes = [...spPanes];
    const idx = panes.findIndex((item) => +item.key === +key);
    panes.splice(idx, 1);

    setSPPanes([...panes]);
  };

  const add = (defectId, data) => {
    const key = String(defectId);
    setActiveState(key);
    if (spPanes.length > cardMaxCount) {
      remove(spPanes[1].key);
    }
    const panes = [...spPanes];
    panes.push({
      label: "Дефект №" + key,
      key,
      card: data,
    });
    setSPPanes(panes);
  };

  const exportRegistry = () => {
    //Api.export(defectRegister.initialFilter);
    Api.exportExcelThread(defectRegister.initialFilter);
  };

  // const openDispatcherLayout = () => {
  //   onOpenValidator();
  // };
  const expandHandle = () => {
    isExpandedDefect.toggle();
  };

  const actions = (
    <div className="defect__actions">
      <ExportIco title="Экспорт реестра в Excel" onClick={exportRegistry} />
      <OpenCardIco
        title="Перейти в реестр дефектов"
        onClick={() => {
          history.push(`/sp/reestr`);
        }}
      />
      {!isExpandedDefect.value ? (
        <ExpandIco title="Расширить таблицу" onClick={expandHandle} />
      ) : (
        <CollapseIco title="Уменьшить таблицу" onClick={expandHandle} />
      )}
    </div>
  );

  const columns = [
    {
      title: "№ п/п",
      dataIndex: "id",
      key: "id",
      width: "5%",
      render: (text) => {
        return (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault();
              defectClick(text);
            }}
          >
            {text}
          </a>
        );
      },
    },
    {
      title: "Организация",
      dataIndex: ["organization", "name"],
      key: "organization",
      width: "15%",
    },
    {
      title: "Адрес дефекта",
      dataIndex: "addressText",
      key: "addressText",
      width: "15%",
    },
    {
      title: "Дата отключения",
      dataIndex: "dateTimeDisable",
      key: "dateTimeDisable",
      width: "8%",
      render: (date: Date) =>
        date ? M(date).format(Constants.dateFormat) : "",
    },
    {
      title: "Дата устранения",
      dataIndex: "dateTimeEnable",
      key: "dateTimeEnable",
      width: "8%",
      render: (date: Date) =>
        date ? M(date).format(Constants.dateFormat) : "",
    },
    {
      title: "Вид ресурса",
      dataIndex: ["gridType", "title"],
      key: "gridType",
      width: "9%",
      render: (value, record) => {
        return record.defNature?.title || value;
      },
    },
    {
      title: "Всего зданий",
      dataIndex: "overBuildings",
      key: "overBuildings",
      width: "8%",
    },
    {
      title: "Жилых зданий",
      dataIndex: "livingBuildings",
      key: "livingBuildings",
      width: "8%",
    },
    {
      title: "Лечебных зданий",
      dataIndex: "hospitalBuildings",
      key: "hospitalBuildings",
      width: "8%",
    },
    {
      title: "Детских зданий",
      dataIndex: "childrenBuildings",
      key: "childrenBuildings",
      width: "8%",
    },
    {
      title: "Ду, мм",
      dataIndex: "diameter",
      key: "diameter",
      width: "8%",
    },
  ];
  const footerClassName = cn({
    "site-custom-footer": true,
    collaps: defectRegister.collapsed.value,
    "open-pantl_left": !defectRegister.siderCollapsed,
  });

  const tableLoading = {
    spinning: defectRegister.isLoadingRegistryList.value,
    indicator: <Spinner />,
  };

  return (
    <Footer className={footerClassName}>
      <div className={"hide-container"}>
        <WrapIco
          title={!defectRegister.collapsed.value ? "Свернуть" : "Развернуть"}
          className={
            !defectRegister.collapsed.value
              ? "sider-filter__icon"
              : "sider-filter__icon rotate"
          }
          onClick={() => defectRegister.collapsed.toggle()}
        />
      </div>

      <Collapse
        className={classNames(
          "custom-footer-collapse",
          defectRegister.collapsed.value
            ? "custom-footer-collapse--hidden"
            : null,
        )}
      >
        <Tabs
          className={"custom-tabs"}
          type="editable-card"
          activeKey={activeState}
          defaultActiveKey={"defectsTable"}
          tabBarExtraContent={actions}
          hideAdd={true}
          onEdit={onEdit}
          onTabClick={onTabClick}
        >
          {spPanes.map((pane) => (
            <TabPane
              tab={pane.label}
              key={pane.key}
              closable={pane.key !== "defectsTable"}
            >
              {pane.key === "defectsTable" && (
                <div>
                  <Table
                    loading={tableLoading}
                    style={{
                      tableLayout: "inherit",
                      height: isExpandedDefect.value ? "70vh" : "auto",
                    }}
                    className="custom-table"
                    columns={columns}
                    dataSource={defectRegister.registryList?.items}
                    pagination={false}
                    locale={{
                      emptyText: <NotFound />,
                    }}
                    scroll={{
                      y: isExpandedDefect.value ? "70vh" : 215,
                      x: 1300,
                    }}
                  />
                </div>
              )}
              {pane.key !== "defectsTable" && (
                <div
                  style={{
                    height: isExpandedDefect.value ? "70vh" : "280px",
                  }}
                >
                  {pane?.card.gridTypeId == 1 && (
                    <table className="defect-card">
                      <tbody>
                        <tr>
                          <td>Идентификатор</td>
                          <td>
                            <span>{pane?.card?.id}</span>
                            <Link
                              to={`/sp/reestr/${pane?.card?.id}`}
                              className="ml-7"
                            >
                              <ArrowRightIco />
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>Организация</td>
                          <td>{pane?.card?.organization?.nameFull}</td>
                        </tr>
                        <tr>
                          <td>Дата отключения/ограничения</td>
                          <td>
                            {M(pane?.card?.dateTimeDisable).format(
                              Constants.dateTimeFormat)}
                          </td>
                        </tr>
                        <tr>
                          <td>Дата устранения дефекта</td>
                          <td>
                            {pane?.card?.dateTimeEnable &&
                              M(pane?.card?.dateTimeEnable).format(
                                Constants.dateTimeFormat,
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td>Административный район</td>
                          <td>{pane?.card?.district?.title}</td>
                        </tr>
                        <tr>
                          <td>Адрес дефекта</td>
                          <td>{pane?.card?.addressText}</td>
                        </tr>
                        <tr>
                          <td>Примечание к адресу</td>
                          <td>{pane?.card?.addressNote}</td>
                        </tr>
                        <tr>
                          <td>Количество отключенных абонентов</td>
                          <td>{pane?.card?.disconnectedSubscribers}</td>
                        </tr>
                        <tr>
                          <td>Тип события</td>
                          <td>{pane?.card?.eventType?.title}</td>
                        </tr>
                        <tr>
                          <td>Всего зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.overBuildings}</td>
                        </tr>
                        <tr>
                          <td>Жилых зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.livingBuildings}</td>
                        </tr>
                        <tr>
                          <td>Лечебных зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.hospitalBuildings}</td>
                        </tr>
                        <tr>
                          <td>Детских зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.childrenBuildings}</td>
                        </tr>
                        <tr>
                          <td>Прочих зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.buildings}</td>
                        </tr>
                        <tr>
                          <td>Характер ограничения</td>
                          <td>{pane?.card?.defNature?.title}</td>
                        </tr>
                        <tr>
                          <td>Ожидаемое дата и время окончания работ</td>
                          <td>
                            {pane?.card?.dateTimePlanned &&
                              M(pane?.card?.dateTimePlanned).format(
                                Constants.dateTimeFormat,
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td>Нормативное время, ч</td>
                          <td>{pane?.card?.standartTime}</td>
                        </tr>
                        <tr>
                          <td>Вид ограничения</td>
                          <td>{pane?.card?.livingTypeRestriction?.title}</td>
                        </tr>
                        <tr>
                          <td>
                            Адреса отключаемых зданий или с ограничениями по ЦО
                          </td>
                          <td>{pane?.card?.addressDisconnexion}</td>
                        </tr>
                        <tr>
                          <td>Источник теплоснабжения</td>
                          <td>{pane?.card?.heatSource}</td>
                        </tr>
                        <tr>
                          <td>Тип прокладки</td>
                          <td>{pane?.card?.typeGasket?.title}</td>
                        </tr>
                        <tr>
                          <td>Тип трубопровода</td>
                          <td>{pane?.card?.typePipe?.title}</td>
                        </tr>
                        <tr>
                          <td>Диаметр трубы (Ду), мм</td>
                          <td>{pane?.card?.diameter}</td>
                        </tr>
                        <tr>
                          <td>Вид работ</td>
                          <td>
                            {pane?.card?.workType?.title ||
                              pane?.card?.typeWork}
                          </td>
                        </tr>
                        <tr>
                          <td>Комментарий</td>
                          <td>{pane?.card?.comment}</td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                  {pane?.card.gridTypeId == 2 && (
                    <table className="defect-card">
                      <tbody>
                        <tr>
                          <td>Идентификатор</td>
                          <td>
                            <span>{pane?.card?.id}</span>
                            <Link
                              to={`/sp/reestr/${pane?.card?.id}`}
                              className="ml-7"
                            >
                              <ArrowRightIco />
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>Организация</td>
                          <td>{pane?.card?.organization?.nameFull}</td>
                        </tr>
                        <tr>
                          <td>Дата отключения/ограничения</td>
                          <td>
                          {M(pane?.card?.dateTimeDisable).format(
                              Constants.dateTimeFormat)}
                          </td>
                        </tr>
                        <tr>
                          <td>Дата устранения дефекта</td>
                          <td>
                            {pane?.card?.dateTimeEnable &&
                              M(pane?.card.dateTimeEnable).format(
                                Constants.dateTimeFormat,
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td>Административный район</td>
                          <td>{pane?.card?.district?.title}</td>
                        </tr>
                        <tr>
                          <td>Адрес дефекта</td>
                          <td>{pane?.card?.addressText}</td>
                        </tr>
                        <tr>
                          <td>Количество отключенных абонентов</td>
                          <td>{pane?.card?.disconnectedSubscribers}</td>
                        </tr>
                        <tr>
                          <td>Тип события</td>
                          <td>{pane?.card?.eventType?.title}</td>
                        </tr>
                        <tr>
                          <td>Всего зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.overBuildings}</td>
                        </tr>
                        <tr>
                          <td>Жилых зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.livingBuildings}</td>
                        </tr>
                        <tr>
                          <td>Лечебных зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.hospitalBuildings}</td>
                        </tr>
                        <tr>
                          <td>Детских зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.childrenBuildings}</td>
                        </tr>
                        <tr>
                          <td>Прочих зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.buildings}</td>
                        </tr>
                        <tr>
                          <td>Характер ограничения</td>
                          <td>{pane?.card?.defNature?.title}</td>
                        </tr>
                        <tr>
                          <td>Ожидаемое дата и время окончания работ</td>
                          <td>
                            {pane?.card?.dateTimePlanned &&
                              M(pane?.card?.dateTimePlanned).format(
                                Constants.dateTimeFormat,
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td>Нормативное время, ч</td>
                          <td>{pane?.card?.standartTime}</td>
                        </tr>
                        <tr>
                          <td>Вытекание</td>
                          <td>{pane?.card?.discharge ? "Да" : "Нет"}</td>
                        </tr>
                        <tr>
                          <td>Тип прокладки</td>
                          <td>{pane?.card?.typeGasket?.title}</td>
                        </tr>
                        <tr>
                          <td>Диаметр трубы (Ду), мм</td>
                          <td>{pane?.card?.diameter}</td>
                        </tr>
                        <tr>
                          <td>Комментарий</td>
                          <td>{pane?.card?.comment}</td>
                        </tr>
                        {/*<tr>*/}
                        {/*  <td>Вид работ</td>*/}
                        {/*  <td>*/}
                        {/*    {pane.card.workType?.title ||*/}
                        {/*      pane.card.typeWork}*/}
                        {/*  </td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*  <td>Произведенные работы</td>*/}
                        {/*  <td>{pane.card.producedWork?.title}</td>*/}
                        {/*</tr>*/}
                      </tbody>
                    </table>
                  )}
                  {pane?.card.gridTypeId == 3 && (
                    <table className="defect-card">
                      <tbody>
                        <tr>
                          <td>Идентификатор</td>
                          <td>
                            <span>{pane?.card?.id}</span>
                            <Link
                              to={`/sp/reestr/${pane?.card?.id}`}
                              className="ml-7"
                            >
                              <ArrowRightIco />
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>Организация</td>
                          <td>{pane?.card?.organization.nameFull}</td>
                        </tr>
                        <tr>
                          <td>Дата отключения/ограничения</td>
                          <td>
                          {M(pane?.card?.dateTimeDisable).format(
                              Constants.dateTimeFormat)}
                          </td>
                        </tr>
                        <tr>
                          <td>Дата устранения дефекта</td>
                          <td>
                            {pane?.card?.dateTimeEnable &&
                              M(pane?.card?.dateTimeEnable).format(
                                Constants.dateTimeFormat,
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td>Административный район</td>
                          <td>{pane?.card?.district?.title}</td>
                        </tr>
                        <tr>
                          <td>Адрес дефекта</td>
                          <td>{pane?.card?.addressText}</td>
                        </tr>
                        <tr>
                          <td>Примечание к адресу</td>
                          <td>{pane?.card?.addressNote}</td>
                        </tr>
                        <tr>
                          <td>Количество отключенных абонентов</td>
                          <td>{pane?.card?.disconnectedSubscribers}</td>
                        </tr>
                        <tr>
                          <td>Всего зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.overBuildings}</td>
                        </tr>
                        <tr>
                          <td>Жилых зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.livingBuildings}</td>
                        </tr>
                        <tr>
                          <td>Лечебных зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.hospitalBuildings}</td>
                        </tr>
                        <tr>
                          <td>Детских зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.childrenBuildings}</td>
                        </tr>
                        <tr>
                          <td>Прочих зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.buildings}</td>
                        </tr>
                        <tr>
                          <td>Тип события</td>
                          <td>{pane?.card?.eventType?.title}</td>
                        </tr>
                        <tr>
                          <td>Диаметр трубы (Ду), мм</td>
                          <td>{pane?.card?.diameter}</td>
                        </tr>
                        <tr>
                          <td>Давление</td>
                          <td>{pane?.card?.pressure}</td>
                        </tr>
                        <tr>
                          <td>Причина нарушения</td>
                          <td>{pane?.card?.reasonNote}</td>
                        </tr>
                        <tr>
                          <td>Ожидаемое дата и время окончания работ</td>
                          <td>
                            {pane?.card?.dateTimePlanned &&
                              M(pane?.card?.dateTimePlanned).format(
                                Constants.dateTimeFormat,
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td>Комментарий</td>
                          <td>{pane?.card?.comment}</td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                  {pane?.card.gridTypeId == 4 && (
                    <table className="defect-card">
                      <tbody>
                        <tr>
                          <td>Идентификатор</td>
                          <td>
                            <span>{pane?.card?.id}</span>
                            <Link
                              to={`/sp/reestr/${pane?.card?.id}`}
                              className="ml-7"
                            >
                              <ArrowRightIco />
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>Организация</td>
                          <td>{pane?.card?.organization.nameFull}</td>
                        </tr>
                        <tr>
                          <td>Дата отключения/ограничения</td>
                          <td>
                          {M(pane?.card?.dateTimeDisable).format(
                              Constants.dateTimeFormat)}
                          </td>
                        </tr>
                        <tr>
                          <td>Дата устранения дефекта</td>
                          <td>
                            {pane?.card?.dateTimeEnable &&
                              M(pane?.card?.dateTimeEnable).format(
                                Constants.dateTimeFormat,
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td>Административный район</td>
                          <td>{pane?.card?.district?.title}</td>
                        </tr>
                        <tr>
                          <td>Адрес дефекта</td>
                          <td>{pane?.card?.addressText}</td>
                        </tr>
                        <tr>
                          <td>Примечание к адресу</td>
                          <td>{pane?.card?.addressNote}</td>
                        </tr>
                        <tr>
                          <td>Инвентарный номер объекта</td>
                          <td>{pane?.card?.inventoryNumber}</td>
                        </tr>
                        <tr>
                          <td>Количество отключенных абонентов</td>
                          <td>{pane?.card?.disconnectedSubscribers}</td>
                        </tr>
                        <tr>
                          <td>Тип события</td>
                          <td>{pane?.card?.eventType?.title}</td>
                        </tr>
                        <tr>
                          <td>Вид работ</td>
                          <td>
                            {pane?.card?.workType?.title ||
                              pane?.card?.typeWork}
                          </td>
                        </tr>
                        <tr>
                          <td>Уточнения вида работ</td>
                          <td>{pane?.card?.typeWorkNote}</td>
                        </tr>
                        <tr>
                          <td>Место работ</td>
                          <td>{pane?.card?.placeWork}</td>
                        </tr>
                        <tr>
                          <td>Характер неисправности</td>
                          <td>{pane?.card?.typeProblem}</td>
                        </tr>
                        <tr>
                          <td>Произведенные работы</td>
                          <td>{pane?.card?.producedWork?.title}</td>
                        </tr>
                        <tr>
                          <td>Комментарий</td>
                          <td>{pane?.card?.comment}</td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                  {pane?.card.gridTypeId == 5 && (
                    <table className="defect-card">
                      <tbody>
                        <tr>
                          <td>Идентификатор</td>
                          <td>
                            <span>{pane?.card?.id}</span>
                            <Link
                              to={`/sp/reestr/${pane?.card?.id}`}
                              className="ml-7"
                            >
                              <ArrowRightIco />
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>Организация</td>
                          <td>{pane?.card?.organization.nameFull}</td>
                        </tr>
                        <tr>
                          <td>Дата отключения/ограничения</td>
                          <td>
                          {M(pane?.card?.dateTimeDisable).format(
                              Constants.dateTimeFormat)}
                          </td>
                        </tr>
                        <tr>
                          <td>Дата устранения дефекта</td>
                          <td>
                            {pane.card?.dateTimeEnable &&
                              M(pane.card?.dateTimeEnable).format(
                                Constants.dateTimeFormat,
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td>Административный район</td>
                          <td>{pane?.card?.district?.title}</td>
                        </tr>
                        <tr>
                          <td>Адрес дефекта</td>
                          <td>{pane?.card?.addressText}</td>
                        </tr>
                        <tr>
                          <td>Примечание к адресу</td>
                          <td>{pane?.card?.addressNote}</td>
                        </tr>
                        <tr>
                          <td>Количество отключенных абонентов</td>
                          <td>{pane?.card?.disconnectedSubscribers}</td>
                        </tr>
                        <tr>
                          <td>Тип события</td>
                          <td>{pane?.card?.eventType?.title}</td>
                        </tr>
                        <tr>
                          <td>Всего зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.overBuildings}</td>
                        </tr>
                        <tr>
                          <td>Жилых зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.livingBuildings}</td>
                        </tr>
                        <tr>
                          <td>Лечебных зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.hospitalBuildings}</td>
                        </tr>
                        <tr>
                          <td>Детских зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.childrenBuildings}</td>
                        </tr>
                        <tr>
                          <td>Прочих зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.buildings}</td>
                        </tr>
                        <tr>
                          <td>Характер ограничения</td>
                          <td>{pane?.card?.defNature?.title}</td>
                        </tr>
                        <tr>
                          <td>Вытекание</td>
                          <td>{pane?.card?.discharge ? "Да" : "Нет"}</td>
                        </tr>
                        <tr>
                          <td>Тип прокладки</td>
                          <td>{pane?.card?.typeGasket?.title}</td>
                        </tr>
                        <tr>
                          <td>Тип трубопровода</td>
                          <td>{pane?.card?.typePipe?.title}</td>
                        </tr>
                        <tr>
                          <td>Диаметр трубы (Ду), мм</td>
                          <td>{pane?.card?.diameter}</td>
                        </tr>
                        <tr>
                          <td>
                            Адреса отключаемых зданий или с ограничениями по ЦО
                          </td>
                          <td>{pane?.card?.addressDisconnexion}</td>
                        </tr>
                        <tr>
                          <td>Альтернативное водоснабжение</td>
                          <td>{pane?.card?.alternativeWaterSupply}</td>
                        </tr>
                        <tr>
                          <td>Ответственный</td>
                          <td>{pane?.card?.responsible}</td>
                        </tr>
                        <tr>
                          <td>Комментарий</td>
                          <td>{pane?.card?.comment}</td>
                        </tr>
                        {/*<tr>*/}
                        {/*  <td>Вид работ</td>*/}
                        {/*  <td>*/}
                        {/*    {pane.card.workType?.title ||*/}
                        {/*      pane.card.typeWork}*/}
                        {/*  </td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                        {/*  <td>Произведенные работы</td>*/}
                        {/*  <td>{pane.card.producedWork?.title}</td>*/}
                        {/*</tr>*/}
                      </tbody>
                    </table>
                  )}
                  {pane?.card.gridTypeId == 6 && (
                    <table className="defect-card">
                      <tbody>
                        <tr>
                          <td>Идентификатор</td>
                          <td>
                            <span>{pane?.card?.id}</span>
                            <Link
                              to={`/sp/reestr/${pane?.card?.id}`}
                              className="ml-7"
                            >
                              <ArrowRightIco />
                            </Link>
                          </td>
                        </tr>
                        <tr>
                          <td>Организация</td>
                          <td>{pane?.card?.organization.nameFull}</td>
                        </tr>
                        <tr>
                          <td>Дата отключения/ограничения</td>
                          <td>
                          {M(pane?.card?.dateTimeDisable).format(
                              Constants.dateTimeFormat)}
                          </td>
                        </tr>
                        <tr>
                          <td>Дата устранения дефекта</td>
                          <td>
                            {pane?.card?.dateTimeEnable &&
                              M(pane?.card?.dateTimeEnable).format(
                                Constants.dateTimeFormat,
                              )}
                          </td>
                        </tr>
                        <tr>
                          <td>Административный район</td>
                          <td>{pane?.card?.district?.title}</td>
                        </tr>
                        <tr>
                          <td>Адрес дефекта</td>
                          <td>{pane?.card?.addressText}</td>
                        </tr>
                        <tr>
                          <td>Количество отключенных абонентов</td>
                          <td>{pane?.card?.disconnectedSubscribers}</td>
                        </tr>
                        <tr>
                          <td>Тип события</td>
                          <td>{pane?.card?.eventType?.title}</td>
                        </tr>
                        <tr>
                          <td>Всего зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.overBuildings}</td>
                        </tr>
                        <tr>
                          <td>Жилых зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.livingBuildings}</td>
                        </tr>
                        <tr>
                          <td>Лечебных зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.hospitalBuildings}</td>
                        </tr>
                        <tr>
                          <td>Детских зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.childrenBuildings}</td>
                        </tr>
                        <tr>
                          <td>Прочих зданий в зоне отключения/ограничения</td>
                          <td>{pane?.card?.buildings}</td>
                        </tr>
                        <tr>
                          <td>Характер ограничения</td>
                          <td>{pane?.card?.defNature?.title}</td>
                        </tr>
                        <tr>
                          <td>Вид работ</td>
                          <td>
                            {pane?.card?.workType?.title ||
                              pane?.card?.typeWork}
                          </td>
                        </tr>
                        <tr>
                          <td>Комментарий</td>
                          <td>{pane?.card?.comment}</td>
                        </tr>
                        <tr>
                          <td>Произведенные работы</td>
                          <td>{pane?.card?.producedWork?.title}</td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                </div>
              )}
            </TabPane>
          ))}
        </Tabs>
      </Collapse>
    </Footer>
  );
});

export default FooterComponent;
